import { gql } from '@apollo/client';

export const GET_ALL_PACKAGES = gql`
  query packages {
    get
      @rest(
        type: "Packages"
        path: "/packages/internal"
        endpoint: "organizations"
      ) {
      id
      legacyPackage
    }
  }
`;

export const GET_ORG_PACKAGES = gql`
  query organizationPackages($organizationId: String!) {
    get(organizationId: $organizationId)
      @rest(
        type: "OrganizationPackages"
        path: "/packages/internal/all/{args.organizationId}"
        endpoint: "organizations"
      ) {
      id
      legacyPackage
    }
  }
`;

export const ENABLE_ORG_PACKAGE = gql`
  mutation impersonate(
    $organizationId: String!
    $packageId: String!
    $body: Body!
  ) {
    post(organizationId: $organizationId, packageId: $packageId, body: $body)
      @rest(
        type: "OrganizationPackageEnable"
        path: "/packages/internal/{args.organizationId}/enable/{args.packageId}"
        endpoint: "organizations"
        bodyKey: "body"
        method: "POST"
      ) {
      id
    }
  }
`;
export const DISABLE_ORG_PACKAGE = gql`
  mutation impersonate($organizationId: String!, $packageId: String!) {
    post(organizationId: $organizationId, packageId: $packageId)
      @rest(
        type: "OrganizationPackageDisable"
        path: "/packages/internal/{args.organizationId}/disable/{args.packageId}"
        endpoint: "organizations"
        method: "DELETE"
      ) {
      id
    }
  }
`;

export const GET_PACKAGE_FEATURES = gql`
  query organizationPackages($packageId: String!) {
    get(packageId: $packageId)
      @rest(
        type: "PackageFeatures"
        path: "/packages/internal/features/{args.packageId}"
        endpoint: "organizations"
      ) {
      id
    }
  }
`;

export const GET_ALL_AVAILABLE_FEATURES = gql`
  query organizationPackages($orgId: String!) {
    get(orgId: $orgId)
      @rest(
        type: "OrgFeatures"
        path: "/organizations/{args.orgId}/specialfeatures"
        endpoint: "organizations"
      ) {
      id
    }
  }
`;

export const GET_ALL_ORGANIZATION_FEATURES = gql`
  query organizationPackages($orgId: String!) {
    get(orgId: $orgId)
      @rest(
        type: "OrgFeatures"
        path: "/organizations/{args.orgId}/allFeatures/status"
        endpoint: "organizations"
      ) {
      enabled
      enabledThroughPackages
      featureId
    }
  }
`;

export const ENABLE_ORG_FEATURE = gql`
  mutation impersonate(
    $organizationId: String!
    $featureId: String!
    $body: Body!
  ) {
    post(organizationId: $organizationId, featureId: $featureId, body: $body)
      @rest(
        type: "OrganizationFeatureEnable"
        path: "/organizations/{args.organizationId}/features/{args.featureId}"
        endpoint: "organizations"
        bodyKey: "body"
        method: "POST"
      ) {
      id
    }
  }
`;
export const DISABLE_ORG_FEATURE = gql`
  mutation impersonate($organizationId: String!, $featureId: String!) {
    post(organizationId: $organizationId, featureId: $featureId)
      @rest(
        type: "OrganizationFeatureDisable"
        path: "/organizations/{args.organizationId}/features/{args.featureId}"
        endpoint: "organizations"
        method: "DELETE"
      ) {
      id
    }
  }
`;
